/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_Eudata_SubInputs */

const en_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const de_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souverän`)
};

const fr_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const es_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const it_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const nl_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const pl_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const fi_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const da_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const sv_landing_compliance_eudata_sub = /** @type {(inputs: Landing_Compliance_Eudata_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

/**
* | output |
* | --- |
* | "Sovereign" |
*
* @param {Landing_Compliance_Eudata_SubInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_eudata_sub = /** @type {((inputs?: Landing_Compliance_Eudata_SubInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_Eudata_SubInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_eudata_sub(inputs)
	if (locale === "fr") return fr_landing_compliance_eudata_sub(inputs)
	if (locale === "es") return es_landing_compliance_eudata_sub(inputs)
	if (locale === "it") return it_landing_compliance_eudata_sub(inputs)
	if (locale === "nl") return nl_landing_compliance_eudata_sub(inputs)
	if (locale === "pl") return pl_landing_compliance_eudata_sub(inputs)
	if (locale === "fi") return fi_landing_compliance_eudata_sub(inputs)
	if (locale === "da") return da_landing_compliance_eudata_sub(inputs)
	if (locale === "sv") return sv_landing_compliance_eudata_sub(inputs)
	return en_landing_compliance_eudata_sub(inputs)
});